export const GraduationMonth = {
  JAN: 'Jan',
  MAR: 'March',
  JUNE: 'June',
  AUG: 'Aug',
};
